import React, { createContext, useContext, useState, useEffect } from 'react';

import axios from 'axios';

// Contextを作成

const AuthContext = createContext();



// カスタムフックを作成

export const useAuth = () => {

    return useContext(AuthContext);

};



// Providerを作成

export const AuthProvider = ({ children }) => {

    const [userId, setUserId] = useState(null);

    

        const fetchUserId = async () => {
            try {

                const apiUrl = process.env.REACT_APP_URL;// || 'https://swap-face-app.com';
                //console.log("API URL:", apiUrl); // デバッグ用ログ
                const response = await axios.get(process.env.REACT_APP_GET_GUEST_ID, {
                    withCredentials: true, // セッション情報を含める
                });
                const { user_id } = response.data; // Flaskのレスポンスからuser_idを取得
                setUserId(user_id); // userIdを設定
                //console.log("user ID:", user_id)
            } catch (error) {
                //console.error("Failed to fetch user ID:", error);
            }
    };
    
    useEffect(() => {
        if (!userId) {
            const interval = setInterval(() => {
                fetchUserId(); // 1秒ごとにクッキーをチェック
            }, 500);

            return () => clearInterval(interval); // クリーンアップ
        }
    }, [userId]); // userIdが変わったときに実行
    



    return (

        <AuthContext.Provider value={{ userId, setUserId }}>
            {children}
        </AuthContext.Provider>

    );

};

